module.exports = __webpack_public_path__ + "img/SP.77c2f5aa.webp";